<template>
    <loading v-if="loading"></loading>
    <div v-else>
        <div>
            <div id="widget_header" class="d-flex justify-content-between">
                <h1>{{widget.header_title}}</h1>
                <button type="button" class="close" aria-label="Close" onclick="window.parent.postMessage('productlift.close', '*')">
                    <span aria-hidden="true">&times;</span>
                </button>
            </div>
        </div>
        <div class="padding">
            <PostForm
                :status="status"
                :section="section"
                :category="category"
                :categories="categories"
                :is-admin="isAdmin"
                :submission-link-target="'_blank'"
                @post-added="handlePostAdded"
                @cancel="handleCancel"
                @reset="resetForm"
            />
        </div>
    </div>
</template>

<script>
import PostForm from '../components/PostForm.vue';
import {
    mapState
} from "vuex";
import Loading
    from "./Loading";
import NotificationPop
    from "../mixins/NotificationPop";

export default {
    components: {
        PostForm,
        Loading
    },
    mixins: [NotificationPop],
    data() {
        return {
            // preset
            status: null,
            section: null,
            category: null,

            categories: [],
            isAdmin: false,
            post: null,
            loading: true,
            widget: [],
        };
    },
    created() {
        this.loadWidgetInfo()

        this.$http.get('/http_api/categories')
            .then(({data}) => {
                this.loading = false;
                this.categories = data.data
            })
            .catch(error => {
                this.loading = false;
                this.popNotification('Something went wrong on our side. Could not load. Please try again or contact ruben@productlift.dev', 'danger')
            });
    },
    methods: {
        loadWidgetInfo() {
            const widgetId = this.$route && this.$route.query && this.$route.query.widget_id;
            if (!widgetId) {
                this.loading = false;
                alert('Cannot load widget, widget id is missing.');
                return;
            }

            return this.$http.get(`/http_api/widgets/${widgetId}`)
                .then(({ data }) => {
                    this.widget = data.data;

                    this.category = this.widget.category_id;
                    this.status = this.widget.status_id;
                    this.section = this.widget.section_id;
                })
                .catch(error => {
                    this.loading = false;
                    console.log(error);
                    this.popNotification('Something went wrong on our side. Could not load widget info. Please try again or contact support.', 'danger');
                });
        },
        handlePostAdded(post) {
            this.post = post
        },
        handleCancel() {
            window.parent.postMessage('productlift.close', '*')
        },
        resetForm() {
            // Optionally reset any page state here
        }
    }
};
</script>
<style scoped>
.padding {
    padding: 0 15px;
}
</style>